import { render } from "./lhc.vue?vue&type=template&id=40a20371&scoped=true"
import script from "./lhc.vue?vue&type=script&lang=js"
export * from "./lhc.vue?vue&type=script&lang=js"

import "./lhc.vue?vue&type=style&index=0&id=40a20371&scoped=true&lang=css"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40a20371"]])

export default __exports__